import { Box, Chip, Stack, Typography } from '@mui/material';

export default function AddonFilesField({ saving, addonFiles, inputRef, onChange, onRemove }) {
  return (
    <Box>
      <Typography variant="body2" sx={{ mb: 0.5 }}>
        Addon files (.mcworld, .mcpack, .mcaddon) — optional for drafts
      </Typography>

      <input
        ref={inputRef}
        type="file"
        multiple
        accept=".mcworld,.mcpack,.mcaddon"
        onChange={onChange}
        disabled={saving}
      />

      {addonFiles.length > 0 && (
        <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap sx={{ mt: 1 }}>
          {addonFiles.map((f, idx) => (
            <Chip
              key={`${f.name}-${f.size}-${idx}`}
              label={f.name}
              onDelete={() => onRemove(idx)}
              size="small"
              variant="outlined"
            />
          ))}
        </Stack>
      )}
    </Box>
  );
}
